/**
 * Calculates the total carbohydrate content based on provided ingredients.
 */
export function calculateTotalCarbs(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalCarbs = [...ingredients].reduce(addCarbs, 0);

  return Math.round(totalCarbs);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.totalCarbsG !== 'number';
}

function addCarbs(total: number, ingredient: Ingredient): number {
  const carbs = typeof ingredient.totalCarbsG === 'number' ? ingredient.totalCarbsG : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + carbs * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredients = Ingredient[] | readonly Ingredient[];
type Ingredient = { totalCarbsG: number | null; quantity?: number };
